import {
  CompaniesResource,
  Items,
} from "@companieshouse/api-sdk-node/dist/services/search/advanced-search/types";
import axios, { AxiosInstance } from "axios";

/**
 * @class CompanyHouseAPI
 * This is a wrapper around the Companies House API sdk, which is designed for nodejs.
 * The sdk is handy as it provides types for the responses, but it is not designed to be used in the browser.
 *
 * Company House API doc {@link https://developer.companieshouse.gov.uk/api/docs/}, document more services we can use.
 *
 * A side note, since the API is free and has decent quota limits, we can use it in the browser, but it needs the domains allowed in the CORS policy.
 *
 * e.g. https://basecamp.dev01.yeti.host is allowed for development.
 *
 */
export class CompanyHouseAPI {
  private chClient: AxiosInstance;
  constructor() {
    this.chClient = axios.create({
      baseURL: import.meta.env.VITE_COMPANY_HOUSE_BASE_URL,
      paramsSerializer: {
        encode: (param) => encodeURIComponent(param),
      },
    });

    this.chClient.interceptors.request.use(async (config) => {
      const ba = btoa(import.meta.env.VITE_COMPANY_HOUSE_API_KEY + ":");
      config.headers.Authorization = `Basic ${ba}`;
      config.headers["X-Request-ID"] = Date.now();
      config.headers["Content-Type"] = "application/json";
      return config;
    });
  }

  async advancedSearchCompanies(term: string): Promise<CompaniesResource> {
    return this.chClient
      .get(`/advanced-search/companies`, {
        params: {
          company_name_includes: term,
          company_status: "active",
          size: 4,
        },
      })
      .then((response) => response.data);
  }

  async getCompany(companyNumber: string): Promise<Items> {
    return this.chClient.get(`/company/${companyNumber}`).then((response) => response.data);
  }
}
